<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <pi-progress v-if="progress"></pi-progress>
          <v-card-title primary-title class="headline">Zmiana hasła</v-card-title>
          <v-card-text>
            <v-form ref="form" @submit="sendHash()" lazy-validation>
              <v-text-field
                v-model="email"
                v-if="!isHashed"
                :rules="Rules.user.email"
                :disabled="progress"
                required
                prepend-icon="person"
                name="email"
                label="Email"
                type="email"
              ></v-text-field>
              <v-text-field
                v-model="password"
                v-if="isHashed"
                :disabled="progress"
                required
                :append-icon="passwordV ? 'visibility' : 'visibility_off'"
                @click:append="() => (passwordV = !passwordV)"
                :type="passwordV ? 'password' : 'text'"
                min="8"
                :rules="Rules.user.password"
                prepend-icon="lock"
                name="password"
                label="Hasło"
              ></v-text-field>
              <v-text-field
                v-model="passwordConfirmation"
                v-if="isHashed"
                :disabled="progress"
                required
                :append-icon="passwordConfirmationV ? 'visibility' : 'visibility_off'"
                @click:append="() => (passwordConfirmationV = !passwordConfirmationV)"
                :type="passwordConfirmationV ? 'password' : 'text'"
                min="8"
                :error-messages="passwordConfirmationErrors"
                prepend-icon="lock"
                name="password_confirmation"
                label="Potwierdzenie hasła"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="progress" flat to="/login">Wróć do logowania</v-btn>
            <v-btn
              v-if="!isHashed"
              flat
              color="accent"
              :disabled="progress"
              v-on:click="sendHash()"
            >Wyślij link do zmiany hasła</v-btn>
            <v-btn
              v-if="isHashed"
              flat
              color="accent"
              :disabled="progress"
              v-on:click="sendHash()"
            >Zmień hasło</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <pi-snackbar :color="snackbar.color" :snackbar.sync="snackbar.on" :message="snackbar.message"></pi-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    progress: false,
    email: "",
    snackbar: { on: false, color: "error", message: "" },
    password: "",
    passwordV: true,
    passwordConfirmation: "",
    passwordConfirmationErrors: [],
    passwordConfirmationV: true
  }),
  computed: {
    id() {
      return this.$route.params.id;
    },
    isHashed() {
      return !!this.id && this.id.length > 0;
    },
    passwordConfirmationValid() {
      return this.password == this.passwordConfirmation;
    },
    url() {
      return this.isHashed ? `/auth/reset/${this.id}` : `/auth/reset/${this.email}`
    },
    apiMethod() {
      return this.isHashed ? 'post' : 'get'
    }
  },
  watch: {
    passwordConfirmationValid(v) {
      this.passwordConfirmationErrors = v
        ? []
        : ["Potwierdzenie hasła nie jest zgodne z wipsanym hasłem"];
    }
  },
  methods: {
    async sendHash() {
      if (!this.$refs.form.validate() || !this.passwordConfirmationValid)
        return;
      this.progress = true;
      const response = await this.Api.send(this.apiMethod, this.url, { password: this.password});
      this.progress = false;
      if (response.status) {
        if (!this.isHashed)
          this.showSuccess("Email z instrukcjami do zmiany hasła został wysłany")
        else
          this.$router.push({ path: '/' });
        return;
      }
      this.showError(response.message);
    },
    showError(message) {
      this.snackbar.color = 'error'
      this.showMessage(message)
    },
    showSuccess(message) {
      this.snackbar.color = 'success'
      this.showMessage(message)
    },
    showMessage(message) {
      this.snackbar.message = message;
      this.snackbar.on = true;
    }
  }
};
</script>